module.exports = __webpack_public_path__ + "static/media/sticker_black.deb012a7.png";